import styles from './Icon.module.scss'

export function Icon(props) {
  const {type} = props
  return (
    <div className={`${styles.icon} ${styles[type]}`}>
    </div>
  )
}
